import React from 'react';
import { SurveyQuestion } from '../types/survey';

interface QuestionComponentProps {
	question: SurveyQuestion;
	value: string | boolean | number | null | undefined;
	onChange: (value: string | boolean | number) => void;
}

const QuestionComponent: React.FC<QuestionComponentProps> = ({ question, value, onChange }) => {
	return (
		<div className='question-container'>
			<div className='question-header'>
				<h3 className='question-text'>{question.title}</h3>
				{question.required && <span className='required-indicator'>*</span>}
			</div>
			<div className='question-input'>
				<div className='question-boolean'>
					<label className='checkbox-option'>
						<input type='checkbox' name={question.id} checked={value === true} onChange={() => onChange(!value)} />
						<span>Da</span>
					</label>
				</div>
			</div>
		</div>
	);
};

export default QuestionComponent;
